import queryString from 'query-string'
import { DicomAPI } from './types'

export const dicomApi: DicomAPI = ky => {
  return {
    async fetch({ patientId, isImportant, cursor }) {
      return ky(`patient/${patientId}/dicom/`, {
        method: 'get',
        searchParams: queryString.stringify({
          // eslint-disable-next-line @typescript-eslint/camelcase
          is_important: isImportant,
          cursor
        })
      }).json()
    },

    async fetchThumbnail({ patientId, dicomId }) {
      return ky(`patient/${patientId}/dicom/${dicomId}/thumbnail/`, {
        method: 'get'
      }).blob()
    },

    async fetchDicom({ patientId, dicomId }) {
      return ky(`patient/${patientId}/dicom/${dicomId}/download/`, {
        method: 'get'
      }).blob()
    },

    async fetchImage({ patientId, dicomId }) {
      return ky(`patient/${patientId}/dicom/${dicomId}/image/`, {
        method: 'get'
      }).blob()
    },

    async fetchOne({ patientId, dicomId }) {
      return ky(`patient/${patientId}/dicom/${dicomId}/`, {
        method: 'get'
      }).json()
    },

    async create({ patientId, payload }) {
      return await ky(`patient/${patientId}/dicom/`, {
        method: 'post',
        body: JSON.stringify({
          title: payload.title,
          description: payload.description,
          isImportant: payload.isImportant || false,
          // eslint-disable-next-line @typescript-eslint/camelcase
          file_name: payload.fileName,
          // eslint-disable-next-line @typescript-eslint/camelcase
          file_content: payload.fileContent
        })
      }).json()
    },

    async update({ patientId, dicomId, payload }) {
      return await ky(`patient/${patientId}/dicom/${dicomId}/`, {
        method: 'put',
        body: JSON.stringify(payload)
      }).json()
    },

    async updateImportant({ patientId, dicomId, isImportant }) {
      return await ky(`patient/${patientId}/dicom/${dicomId}/`, {
        method: 'patch',
        body: JSON.stringify({ isImportant })
      }).json()
    },

    async patch({ patientId, dicomId, payload }) {
      return await ky(`patient/${patientId}/dicom/${dicomId}/`, {
        method: 'patch',
        body: JSON.stringify(payload)
      }).json()
    },

    async delete({ patientId, dicomId }) {
      await ky(`patient/${patientId}/dicom/${dicomId}/`, {
        method: 'delete'
      })
    }
  }
}
